(function () {
  'use strict';

  angular
      .module('tfc.retailer.FitConsistency')
      .controller('FitConsistencyCtrl', FitConsistencyCtrl);

  // @ngInject
  function FitConsistencyCtrl($state, $stateParams, PageSize, hierarchies, brands, translateFilter, CookieJar,
                              styleData, $scope, FitConsistencyReport, GaUtil, ChartService,
                              filters, aggregationLogDetails) {
    var vm = this;
    vm.brands = brands;
    vm.selectedBrand = _.find(vm.brands, {key: $stateParams.brandKey});
    vm.pageSize = PageSize;
    vm.totalCount = styleData ? styleData.totalCount : 0;
    vm.filteredCount = vm.totalCount;
    vm.maxSize = 7;
    vm.offsets = [];

    vm.gaUtil = GaUtil;
    vm.filteredText = "";
    vm.animationsEnabled = true;
    vm.isProductDetailAccessible = $state.can('productDetail');
    vm.aggregationDetails = aggregationLogDetails;

    function initSortConfig() {
      if($stateParams.hierarchy === ALL_CATEGORIES){
        vm.selectedSortField = 'categoryName';
      }else{
        vm.selectedSortField = $stateParams.sortBy === 'categoryName' ?  'styleTitle' : $stateParams.sortBy;
      }
      vm.selectedSortOrder = $stateParams.sortOrder || 'asc';
    }

    function setSortConfig(columnName, order) {
      vm.selectedSortField = columnName;
      vm.selectedSortOrder = order;
    }

    function initializeState(){
      vm.currentPage = $stateParams.pageNumber || 1;
      initSortConfig();
      vm.sortByColumn();
    }

    vm.hierarchies= _(hierarchies).map(function(o){
      return {
        department: o.department,
        category: o.category,
        display: o.category ? o.department + "/" + o.category : o.department
      }
    }).value();

    vm.translateText = function (text) {
      return translateFilter('reports.returns.' + text)
    };

    var ALL_CATEGORIES = vm.translateText('allCategories');

    vm.hierarchies.unshift({ display : ALL_CATEGORIES });

    if(!$stateParams.hierarchy || $stateParams.hierarchy === ALL_CATEGORIES) {
      vm.selectedHierarchy = vm.hierarchies[0];
      vm.currentPage = 1;
    } else {
      vm.selectedHierarchy = _.find(vm.hierarchies, {department: $stateParams.department, category: $stateParams.category});
      vm.currentPage = 1;
      if(!vm.selectedHierarchy){
        vm.selectedHierarchy = vm.hierarchies[0];
      }
    }

    vm.unfilteredData = _(styleData && styleData.items).map(function(data){
      return {
        supplierStyle : data.supplierStyle,
        styleTitle : data.styleTitle,
        sizeAdvice: data.sizeAdvice
      }
    }).value();

    vm.unfilteredCategoryData = _(hierarchies).map(function(data) {
      return {
        styleTitle : data.category ? data.department + "/" + data.category : data.department,
        sizeAdvice : data.sizeAdvice
      }
    }).value();

    vm.activityRegionFilters = filters;

    var selectedTransaction = vm.activityRegionFilters && vm.activityRegionFilters.getSelected();
    var selectedRegion = selectedTransaction && selectedTransaction.getSelectedRegion();

    vm.selectActivityAndReload = function(activity){
      selectedTransaction = activity;
      vm.gaUtil.sendGaEvent(vm.selectedBrand.key, 'Activity Filter', activity.label);
      vm.reload(false);
    };

    vm.selectRegionAndReload = function (region) {
      selectedRegion = region;
      vm.gaUtil.sendGaEvent(vm.selectedBrand.key, 'Region Filter', region.labelDescription);
      vm.reload(false);
    };

    vm.selectedBrandReload = function(selectedBrand){
      vm.selectedBrand = selectedBrand;
      vm.reload(true);
    };

    vm.reload = function(resetBrand) {
      CookieJar.set({name : 'tfc-insight-selected-brand',value : encodeURIComponent(_.toString(vm.selectedBrand.key))});

      if(!resetBrand) {
        $state.go('.', { brandKey : vm.selectedBrand.key, hierarchy: vm.selectedHierarchy.display,
          department: vm.selectedHierarchy.department, category: vm.selectedHierarchy.category,
          transaction: selectedTransaction && selectedTransaction.getLabel(),
          region: selectedRegion && selectedRegion.getLabel(),
          pageNumber: vm.currentPage} );
      } else {
        $state.go('.', { brandKey : vm.selectedBrand.key},{inherit: false});
      }
    };

    vm.downloadFctReport = function () {
      var hierarchy = vm.selectedHierarchy;
      FitConsistencyReport.downloadReport(hierarchy && hierarchy.display, vm.selectedBrand && vm.selectedBrand.key,
          hierarchy && hierarchy.department, hierarchy && hierarchy.category,
          selectedRegion && selectedRegion.getLabel(),
          selectedTransaction && selectedTransaction.getLabel(),
          vm.selectedSortField, vm.selectedSortOrder,
          vm.activityRegionFilters && vm.activityRegionFilters.hasMultipleActivity(),
          selectedTransaction && selectedTransaction.hasMultipleRegion());
    };

    function getUnfilteredData(){
      return (vm.selectedHierarchy && vm.selectedHierarchy.display === ALL_CATEGORIES) ? vm.unfilteredCategoryData: vm.unfilteredData;
    }

    function getFilteredData(data){
      return _.filter(data, function(row) {
        if((row.supplierStyle && row.supplierStyle.toLowerCase().indexOf(vm.filteredText.toLowerCase()) !== -1) ||
            (row.styleTitle && row.styleTitle.toLowerCase().indexOf(vm.filteredText.toLowerCase()) !== -1)) return row;
      });
    }

    vm.setFitChart = function(dataObject, other){
      var unFilterDataArray = [];
      if(dataObject && dataObject.length) {
        unFilterDataArray = dataObject;
      } else {
        unFilterDataArray = getUnfilteredData();
      }
      vm.offsets = [];
      var finalDataArray = other.isFiltered ? getFilteredData(unFilterDataArray) : unFilterDataArray;
      vm.filteredCount = finalDataArray.length;
      vm.chartVarianceData = _(finalDataArray.slice((other.currentPage - 1) * vm.pageSize, other.currentPage * vm.pageSize)).map(function (data) {
        return {
          supplierStyle : data.supplierStyle,
          styleTitle : data.styleTitle,
          sizeAdviceChart : ChartService.getSizeAdviceChart([{sizeAdvice: data.sizeAdvice}])
        }
      }).value();
    };
    
    vm.setFilteredText = function (filteredText) {
      vm.currentPage = 1;
      vm.filteredText = filteredText;
      vm.isFiltered = true;
      vm.sortByColumn();
    };

    vm.applyPagination = function(currentPage){
      vm.currentPage = currentPage;
      vm.sortByColumn();
    };

    function updateUrl(){
      var paramsObj = {
        pageNumber: vm.currentPage,
        sortBy: vm.selectedSortField,
        sortOrder: vm.selectedSortOrder
      };
      $state.go('.', paramsObj, {notify: false});
    }

    vm.sortByColumn = function (columnName) {
      setSortConfig(columnName || vm.selectedSortField, vm.selectedSortOrder);
      updateUrl();

      var selectedData = getUnfilteredData();
      var unfilteredData = _.orderBy(selectedData,function(style){
        switch(vm.selectedSortField) {
          case 'supplierStyle' :
            return _.lowerCase(style.supplierStyle);
          case 'styleTitle' :
          case 'categoryName':
            return _.lowerCase(style.styleTitle);
          case 'trueToSize' :
            return Math.abs(style.sizeAdvice);
          case 'runsLarge' :
            return -1 * style.sizeAdvice;
          case 'runsSmall' :
            return  style.sizeAdvice;
        }
      }, vm.selectedSortOrder);
      vm.setFitChart(unfilteredData, {currentPage: vm.currentPage, isFiltered: vm.isFiltered});
    };

    vm.onColumnSelection = function(columnName) {
      vm.currentPage = 1;     //reset to first page
      //toggle the sort order if same column is selected again
      if(columnName === vm.selectedSortField) {
        vm.selectedSortOrder = vm.selectedSortOrder === 'asc' ? 'desc' : 'asc';
      } else {
        vm.selectedSortOrder = 'asc';
      }
      vm.sortByColumn(columnName);
    };

    vm.isUnsorted = function(columnName) {
      return vm.selectedSortField !== columnName;
    };

    vm.getSortClass = function(columnName){
      var sort = 'fa fa-sort';
      if(vm.selectedSortField === columnName) {
        return sort+'-'+vm.selectedSortOrder;
      }else {
        return sort;
      }
    };

    vm.navigatePage = function(styleId){
      if(vm.isProductDetailAccessible && styleId) {
        var params = _.merge($stateParams, {
          styleId: styleId,
          regionDescription: selectedRegion && selectedRegion.labelDescription,
          previousState: $state.current && $state.current.data && $state.current.data.title,
          sortBy: vm.selectedSortField,
          sortOrder: vm.selectedSortOrder
        });
        $state.go('productDetail', params);
      }
    };

    initializeState();

  }

})();